module.exports = __webpack_public_path__ + "img/joim_resume01@2x.764a2fe8.png";